@if (round) {
  <h6>{{ group.name }}, {{ round.name }}:</h6>
  @if (round.status != 'FINISHED') {
    <table class="table table-sm m-4 wide w-100">
      <tbody>
        @for (match of round.matches; track match.id) {
          <tr>
            <td class="align-middle" style="width: 45%;">
              <app-team-display
                [team]="match.team1"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            </td>
            <td class="align-middle w-sep">-</td>
            <td class="align-middle" style="width: 45%;">
              <app-team-display
                [team]="match.team2"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            </td>
            <td class="align-middle w-sep"></td>
          </tr>
        }
        @if (round.drawnOut) {
          <tr>
            <td class="align-middle w-100" colspan="4"><b>Deze ronde uitgeloot:</b> {{ round.drawnOut | teamText }}</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <table class="table table-sm m-4 wide w-100">
      <tbody>
        @for (match of round.matches; track match.id) {
          <tr>
            <td class="align-middle" style="width: 30%;">
              <app-team-display
                [team]="match.team1"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            <td class="align-middle w-sep">-</td>
            <td class="align-middle" style="width: 30%;">
              <app-team-display
                [team]="match.team2"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            </td>
            <td class="align-middle" style="width: 35%;">
              <div class="row result align-items-center">
                @for (game of match.games; track game.id) {
                  <span class="col-3">{{ game.score1 }}-{{ game.score2 }}</span>
                }
                @if (match.games.length == 2) {
                  <span class="col-3"></span>
                }
              </div>
            </td>
          </tr>
        }
        @if (round.drawnOut) {
          <tr>
            <td class="align-middle w-100" colspan="4"><b>Deze ronde uitgeloot:</b> {{ round.drawnOut | teamText }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (round.status == 'FINISHED' || prevRound) {
    @if (group.status == 'FINISHED') {
      <h6>Eindstand:</h6>
    } @else if (round.status == 'FINISHED') {
      <h6>Stand na {{ round.name }}:</h6>
    } @else {
      <h6>Stand na {{ prevRound?.name }}:</h6>
    }
    <table class="table table-sm w-100 m-4">
      <thead>
      <tr>
        <th>#</th>
        <th>
          @if (event.doublesEvent) {
            Team
          } @else {
            Speler
          }
        </th>
        <th>Gespeeld</th>
        <th>Punten/W</th>
        <th>Games/W</th>
        <th>#/W</th>
      </tr>
      </thead>
      <tbody class="table-group-divider">
        @for (entry of round.standings.entries; track entry.position) {
          <tr>
            <td class="align-middle">{{ entry.position }}</td>
            <td class="align-middle">
              <app-team-display
                [team]="entry.team"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true"
                [explicitSubstitute]="true">
              </app-team-display>
            </td>
            <td class="align-middle">{{ entry.played }}</td>
            <td class="align-middle">{{ entry.points / entry.played | number: '1.0-2' }}</td>
            <td class="align-middle">{{ (entry.gamesWon - entry.gamesLost) / entry.played | number: '1.0-2' }}</td>
            <td class="align-middle">{{ (entry.pointsWon - entry.pointsLost) / entry.played | number: '1.0-2' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
}
